import { Icon, InputLabel, Rating, Tooltip } from '@mui/material'
import React from 'react'
import { getI18n } from 'react-i18next'
import '../styles/skillbar.scss'

interface OPSkillbar {
  name: string
  value?: number
  readonly?: boolean
  disabled?: boolean
  onChange?: (e: React.SyntheticEvent<Element, Event>, newVal: number | null) => void
  maxRating?: number
  hasLabel?: boolean
  label?: string
  darklabel?: boolean
  showLevelText?: boolean
}

// Ekspertti – Taitava suorittaja – Pätevä ongelmanratkaisija – Kehittynyt aloittelija – Noviisi
// Expert – Proficient Performer – Competent Performer – Advanced Beginner – Novice

export const OPSkillbar = (props: OPSkillbar): JSX.Element => {
  const { name, value, readonly, disabled, onChange, maxRating, hasLabel = false, darklabel = false, label, showLevelText = false } = props

  const i18n = getI18n()
  const lang = i18n.language === 'en' ? 'en' : 'fi'
  const LEVEL_TEXTS: Record<'fi' | 'en', string[]> = {
    fi: ['Noviisi', 'Kehittynyt aloittelija', 'Pätevä ongelmanratkaisija', 'Taitava suorittaja', 'Ekspertti'],
    en: ['Novice', 'Advanced beginner', 'Competent Performer', 'Proficient Performer', 'Expert'],
  }

  const max = maxRating ?? 5
  // Map the current value to a 1–5 index for labels, even if maxRating differs
  const labelIndex = typeof value === 'number' && value > 0 ? Math.min(5, Math.max(1, Math.round((value / max) * 5))) - 1 : -1
  const levelText = labelIndex >= 0 ? LEVEL_TEXTS[lang][labelIndex] : undefined
  const levelDescription = levelText ? i18n.t(`SkillDescriptions.${levelText}`) : undefined
  const hasDescription = levelDescription && levelDescription !== `SkillDescriptions.${levelText}`

  return (
    <>
      {hasLabel && (
        <InputLabel className={'skillLabel' + (darklabel ? ' darklabel' : '')}>
          <span className={'typoLabelSkills'}>{label}</span>
        </InputLabel>
      )}
      <Tooltip title={levelText ?? ''} disableHoverListener={!levelText} arrow>
        <span>
          {/* span wrapper ensures Tooltip works even when Rating is disabled/readonly */}
          <Rating
            data-testid={name}
            className='skillStyling'
            emptyIcon={<Icon className='skillButton' fontSize='inherit' />}
            icon={<Icon className='skillButton' fontSize='inherit' />}
            name={name}
            value={value}
            onChange={(e, newVal) => {
              if (newVal !== null && newVal > 0) onChange?.(e, newVal)
            }}
            readOnly={readonly}
            disabled={disabled}
            max={maxRating}
          />
        </span>
      </Tooltip>
      {levelText && showLevelText && (
        <div className={'skillLabel' + (darklabel ? ' darklabel' : '')}>
          <InputLabel>
            <span className='typoLabelSkills'>{levelText}</span>
          </InputLabel>
          {hasDescription && (
            <div className='typoLabelSkills' style={{ fontSize: '0.75rem', lineHeight: 1.2, marginTop: 4 }}>
              {levelDescription}
            </div>
          )}
        </div>
      )}
    </>
  )
}
